<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>商户分账</el-breadcrumb-item>
        <el-breadcrumb-item>统统付</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
          </span>
        </li>
        <li>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="dialoginfo.show=true">添加</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">

    </div>
    <!-- 编辑产品弹框 -->
    <el-dialog :title="dialoginfo.flag?'添加开户':'编辑开户'" :visible.sync="dialoginfo.show" @close="editinit" custom-class="gs_dialog" width="600px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class='tit'>手机号</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.mobile_no"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>姓名</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.realname"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>证件类型</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.id_type"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>证件号码</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.id_no"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>身份证正面</span>
            <span class="txtbox" style="width:200px;">
              <el-upload
                class="upload-demo"
                ref="upload1"
                :limit="1"
                action=""
                :auto-upload="false"
              >
                <el-button
                  slot="trigger"
                  class="transtionbtn"
                  :class="{ on: dialoginfo.id_card_front }"
                  size="small"
                  type="success"
                >选取文件</el-button>
              </el-upload>
            </span>
            <span class="txtbox" style="width:200px;">
              <el-button
                size="small"
                type="primary"
                @click="submitUpload1"
                :loading="!flag1"
              >上传</el-button>
            </span>
          </li>
          <li>
            <span class='tit'>身份证背面</span>
            <span class="txtbox" style="width:200px;">
              <el-upload
                class="upload-demo"
                ref="upload2"
                :limit="1"
                action=""
                :auto-upload="false"
              >
                <el-button
                  slot="trigger"
                  class="transtionbtn"
                  :class="{ on: dialoginfo.id_card_back }"
                  size="small"
                  type="success"
                >选取文件</el-button>
              </el-upload>
            </span>
            <span class="txtbox" style="width:200px;">
              <el-button
                size="small"
                type="primary"
                @click="submitUpload2"
                :loading="!flag2"
              >上传</el-button>
            </span>
          </li>
          <li>
            <span class='tit'>证件有效期开始时间</span>
            <span class="txtbox" style="width:300px;">
              <el-date-picker
                v-model="dialoginfo.id_start_date"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </span>
          </li>
          <li>
            <span class='tit'>证件有效期结束时间</span>
            <span class="txtbox" style="width:300px;">
              <el-date-picker
                v-model="dialoginfo.id_end_date"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </span>
          </li>
          <li>
            <span class='tit'>登录密码</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.login_password"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>支付密码</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.pay_password"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>职业</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.career"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>用户地址</span>
            <span class="txtbox" style="width:400px;">
              <el-input size="small" v-model="dialoginfo.address"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdb10">
        <el-button v-if="dialoginfo.flag" size="small" type="primary" @click="register">提交</el-button>
        <el-button v-else size="small" type="primary" @click="modify">提交</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'sumpay',
  data() {
    return {
      tenantId: '', // 商户Id
      accountnumber: '', // 商户账号
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      flag1: true,
      flag2: true,
      dialoginfo: {
        flag: true, // 增加与编辑弹框flag
        show: false, // 弹框的显隐
        mobile_no: '', // 手机号
        realname: '', // 姓名
        id_type: '', // 证件类型
        id_no: '', // 证件号码
        id_card_front: '', // 身份证正面
        id_card_back: '', // 身份证背面
        id_start_date: '', // 证件有效期开始时间
        id_end_date: '', // 证件有效期结束时间
        login_password: '', // 登录密码
        pay_password: '', // 支付密码
        career: '', // 职业
        address: '' // 用户地址
      }
    };
  },
  methods: {
    submitUpload1() {
      if (this.id_card_front.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag1) {
        this.flag1 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList1[0].raw);
      this.$api.systemset
        .uploadFileNew(form, 'Wg', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload1.clearFiles();
          this.fileList1 = [];
          this.flag1 = true;
        })
        .catch(err => {
          this.flag1 = true;
          this.$messageError(err.message);
        });
    },
    submitUpload2() {
      if (this.fileList1.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag1) {
        this.flag1 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList1[0].raw);
      this.$api.systemset
        .uploadFileNew(form, 'Wg', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload1.clearFiles();
          this.fileList1 = [];
          this.flag1 = true;
        })
        .catch(err => {
          this.flag1 = true;
          this.$messageError(err.message);
        });
    },
    register() {
    },
    modify() {
    }
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.gs_tablebox {
  padding-bottom: 10px;
}

</style>
